import React from 'react';
import { Route } from 'react-router';

import CoachingAvailabilityContainer from 'coaching/CoachingAvailabilityContainer';
import CoachingChatStreamContainer from 'coaching/CoachingChatStreamContainer';
import CoachingConstants from 'coaching/CoachingConstants';
import CoachingCoordinatorContainer from 'coaching/CoachingCoordinatorContainer';
import CoachingSelfServeContainer from 'coaching/CoachingSelfServeContainer';
import CoachingIntroContainer from 'coaching/CoachingIntroContainer';
import CoachingHomeContainer from 'coaching/CoachingHomeContainer';
import chainOnEnter from 'components/lib/chainOnEnter';
// @ts-ignore
import RequireUser from 'lib/RequireUser';
import { redirectIfMobile } from 'coaching/lib/deviceType';

export const CoachingIsolatedRoutes = (
  <>
    <Route
      path={CoachingConstants.COACHING_PURCHASE_INTRO_ROUTE}
      component={CoachingIntroContainer}
    />
    <Route
      path={CoachingConstants.COACHING_PURCHASE_REVIEW_ROUTE}
      component={CoachingSelfServeContainer}
      onEnter={RequireUser}
    />
    <Route
      path={CoachingConstants.COACHING_COORDINATOR_ROUTE}
      component={CoachingCoordinatorContainer}
      onEnter={RequireUser}
    />
    {/* No left nav bar on mobile home */}
    <Route
      path={CoachingConstants.COACHING_HOME_MOBILE_ROUTE}
      component={CoachingHomeContainer}
      onEnter={RequireUser}
    />
  </>
);

export const CoachingRoutes = (
  <>
    <Route
      path={CoachingConstants.COACHING_CHAT_STREAM_ROUTE}
      component={CoachingChatStreamContainer}
      onEnter={RequireUser}
    />
    <Route
      path={CoachingConstants.COACHING_AVAILABILITY_ROUTE}
      component={CoachingAvailabilityContainer}
      onEnter={RequireUser}
    />
    <Route
      path={CoachingConstants.COACHING_HOME_ROUTE}
      component={CoachingHomeContainer}
      onEnter={chainOnEnter([
        redirectIfMobile(CoachingConstants.COACHING_HOME_MOBILE_ROUTE),
        RequireUser,
      ])}
    />
  </>
);
